import Markdown from 'react-markdown'
import styles from './vehicle-deals.module.scss'

import { VehicleCard } from '@/components/styleguide/Card/Vehicle'
import { Carousel } from '@/components/styleguide/Carousel'
import { SearchResult } from '@/types/search'

export type VehicleDealsProps = {
  isVans: boolean
  title?: string
  content?: string
  dealList: SearchResult[]
}

export const VehicleDeals = ({
  isVans,
  title,
  content,
  dealList,
}: VehicleDealsProps) => {

  return (
    <Carousel
      header={
        <div className={styles.header}>
          <h3>{title}</h3>
          <Markdown>
            {content}
          </Markdown>
        </div>
      }
      scrollValue={344}
      moreLink={`/${isVans ? 'van' : 'car'}-leasing/search`}
      moreLabel={'See more'}
      overwriteMoreLabel={true}
      sectionName={'vehicle-deals'}
      className={styles.carousel}>
      {dealList.length ? (
        dealList.map(deal => (
          <VehicleCard
            deal={deal}
            key={deal.vehiclePrice.id}
            type="vehicle-deals"
          />
        ))
      ) : (
        <div className={styles.loader}></div>
      )}
    </Carousel>
  )
}
